import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ModeSwitcher({ isChatMode, compact }) {
  const navigate = useNavigate();

  if (compact) {
    return (
      <div className="flex flex-col gap-1 w-full">
        <button
          onClick={() => navigate('/ai-chat')}
          title="Chat Bisnis"
          className={`w-9 h-9 mx-auto rounded-lg text-xs font-medium transition-colors ${
            isChatMode ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-400 hover:text-slate-600'
          }`}
        >
          C
        </button>
        <button
          onClick={() => navigate('/')}
          title="Dashboard"
          className={`w-9 h-9 mx-auto rounded-lg text-xs font-medium transition-colors ${
            !isChatMode ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-400 hover:text-slate-600'
          }`}
        >
          D
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-0.5 p-0.5 bg-black/[0.04] rounded-lg w-full">
      <button
        onClick={() => navigate('/ai-chat')}
        className={`flex-1 text-center px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          isChatMode ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        Chat Bisnis
      </button>
      <button
        onClick={() => navigate('/')}
        className={`flex-1 text-center px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          !isChatMode ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        Dashboard
      </button>
    </div>
  );
}
